const LAST_SEEN_TS_KEY = 'worklet-logs-last-seen';

export { LAST_SEEN_TS_KEY };
